export const SetCellPropsWidth = (width) => {
  return () => ({
    style: { minWidth: width, maxWidth: width },
  });
};
